<template>
  <div class="rui-tabs" :class="componentCSS">
    <slot />
  </div>
</template>

<script>
/**
 * Display a list of `.rui-button`s as tabs.
 *
 * The tab content and logic has to be handled separately.
 *
 * @preset Default { "slots": { "default": "<button class=\"rui-button rui-button--active\">Tab 1</button>\n<button class=\"rui-button\">Tab 2</button>\n<button class=\"rui-button\">Tab 3</button>" } }
 */
export default {
  name: 'RuiTabs',
  props: {
    /** Whether to hide text from buttons. Only works well with a `RuiButton` containing an icon. */
    noTextOnSmall: { required: false, type: Boolean, default: false },
  },
  computed: {
    componentCSS () {
      return [
        this.noTextOnSmall && 'rui-tabs--no-text-on-small',
      ]
    },
  },
}
</script>
